import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PasswordLoggedOutResetComponent } from './password-logged-out-reset.component';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

@NgModule({
    declarations: [PasswordLoggedOutResetComponent],
    imports: [
        CommonModule,
        BrowserModule,
        FormsModule,
        SharedModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatAutocompleteModule,
    ],
    exports: [
        PasswordLoggedOutResetComponent,
        CommonModule,
        BrowserModule,
        FormsModule,
    ],
})
export class PasswordLoggedOutResetModule {}
